import { axiosInstance as request } from '@api/rest.service'

const api = '/layouts'

/**
 * @description GET /layouts
 * @returns {AxiosPromise<any>}
 */
export const GET_LAYOUTS = () => request.get(api)

/**
 * @description PUT /layouts/sub-contexts/{id}/definition
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_LAYOUT = (id, payload) => request.put(`${api}/sub-contexts/${id}/definition`, payload)
